/**
 * @desc 通过sku获取sku军团名称和分类名称列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.SkuCorpsInfoAndCategoryRpcResponseDto>
>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuCorpsInfoAndCategory`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
